<template>
	<div>
		<b-form-group>
			<div v-for="(alternative, index) in alternatives" v-bind:key="index">
				<b-row>
					<b-col cols="1">
						<b-form-checkbox
							:name="fieldInfo.name + 'CheckBox'"
							v-model="selectedIndex"
							:value="index"
							class="mt-2 roundedCheckbox"
							@change="radioChange(index, selectedIndex)"
							:disabled="!active || (typeof lockedFields === 'function' ? lockedFields(alternative) : lockedFields)"
						>
						</b-form-checkbox>
					</b-col>
					<b-col :cols="configurations.AllowScore ? 4 : 6">
						<b-form-input
							type="text"
							:size="fieldInfo.size"
							:state="state"
							v-model="alternative.description"
							@input="onTextInput(index, 'description', $event)"
							:name="fieldInfo.name"
							@change="fieldChange(index, alternative.description)"
							:readonly="!active || (typeof lockedFields === 'function' ? lockedFields(alternative) : lockedFields)"
							:key="active"
						></b-form-input>
					</b-col>
					<b-col cols="3">
						<b-form-input
							type="text"
							:size="fieldInfo.size"
							:state="state"
							v-model="alternative.codeERP"
							@input="onTextInput(index, 'codeERP', $event)"
							:placeholder="$t('components.kQuestionItemGroup.shortCodeERP')"
							:name="fieldInfo.name"
							@change="fieldChange(index, alternative.description)"
							:readonly="!active"
							:key="active"
						></b-form-input>
					</b-col>
					<b-col v-if="configurations.AllowScore" cols="2">
						<b-form-input
							type="number"
							:state="state"
							v-model="alternative.score"
							:placeholder="$t('components.kQuestionItemGroup.score')"
							@change="fieldChange(index, alternative.description)"
							:readonly="!active"
							:key="active"
						></b-form-input>
					</b-col>
					<b-col cols="2">
						<b-button
							:variant="alternatives.length < 2 ? 'outline-dark' : 'outline-danger'"
							:disabled="
								!active ||
								alternatives.length < 2 ||
								(typeof lockedFields === 'function' ? lockedFields(alternative) : lockedFields)
							"
							class="border-0 cursor-pointer"
							@click="deleteOption(index)"
							v-b-tooltip.hover="{
								title: $t('buttons.erase'),
								customClass: 'custom-tooltip',
								interactive: false,
								placement: 'bottom'
							}"
						>
							<b-icon icon="trash" class="deleteQuestionIcon" />
						</b-button>
						<b-button
							v-if="alternative.idAlternative > 0"
							variant="outline-dark"
							class="border-0 cursor-pointer"
							@click="onOpenConditionScreenClick(index)"
							v-b-tooltip.hover="{
								title: $t('components.kQuestionItemGroup.createCondition'),
								customClass: 'custom-tooltip',
								interactive: false,
								placement: 'bottom'
							}"
						>
							<b-icon icon="three-dots" />
						</b-button>
					</b-col>
				</b-row>
			</div>
		</b-form-group>
		<div class="add-text" :disabled="!active" @click="addNewOption">
			{{ $t("components.kQuestionItemGroup.addOption") }}
		</div>

		<b-form-invalid-feedback :id="`${fieldInfo.name}-feedback`" :state="state">
			{{ errors[fieldInfo.name] }}
		</b-form-invalid-feedback>
	</div>
</template>

<script>
import ModalMixin from "@/mixins/ModalMixin";
import { mapGetters } from "vuex";

export default {
	mixins: [ModalMixin],
	props: {
		fieldInfo: {
			type: Object
		},
		state: {
			type: Boolean,
			default: null
		},
		alternatives: {
			type: Array,
			default: () => [],
			required: true
		},
		errors: {
			type: Object
		},
		isActive: {
			type: [Boolean, Function],
			required: true
		},
		toUpperCase: {
			type: Boolean,
			default: false
		},
		lockedFields: {
			type: [Function]
		}
	},
	data() {
		return {
			lastIdAlternative: 1,
			active: false,
			excludeRadioGroupModal: {
				message: this.$t("components.kQuestionItemGroup.excludeConfirm"),
				title: this.$t("commons.attention"),
				okTitle: this.$t("buttons.exclude"),
				cancelTitle: this.$t("buttons.cancel"),
				centered: true
			}
		};
	},
	computed: {
		...mapGetters(["configurations"]),
		selectedIndex: {
			get() {
				return this.alternatives.findIndex((alternative) => alternative.isDefault);
			},
			set(newValue) {
				this.$emit("change", this.fieldInfo.name);
				this.$emit("input", newValue);
			}
		}
	},
	methods: {
		onTextInput(index, field, value) {
			if (this.toUpperCase && typeof value === "string") {
				value = value.toUpperCase();
			}
			this.$set(this.alternatives[index], field, value);
		},
		getNewIdAlternative: function () {
			this.lastIdAlternative++;
			return this.lastIdAlternative * -1;
		},
		addNewOption() {
			this.alternatives.push({
				idAlternative: this.getNewIdAlternative(),
				description: "",
				isDefault: false,
				score: null
			});
		},
		deleteOption: function (index) {
			// TODO @rafael.silva não deixar apagar caso exista alguma condição fazendo referencia à alternativa
			this.excluirModal(this.excludeRadioGroupModal).OK(() => {
				this.alternatives.splice(index, 1);
			});
		},
		radioChange: function (index, selectedIndex) {
			this.alternatives.forEach((alternative) => (alternative.isDefault = false));
			if (index != selectedIndex) this.alternatives[index].isDefault = true;
		},
		fieldChange: function (index, newValue) {
			this.alternatives[index].description = newValue;
			this.$emit("change", this.fieldInfo.name);
		},
		onOpenConditionScreenClick: function (index) {
			this.$emit("openAlternativeCondition", this.alternatives[index].idAlternative);
		},
		parentChanged: function (parentValue) {
			if (typeof this.isActive == "function") {
				this.active = this.isActive(parentValue);
				if (this.value) {
					// TODO @rafael.silva achar um hack melhor pra fazer isso
					this.alternatives.push("");
					this.alternatives.pop();
				}
			}
		}
	},
	beforeMount() {
		if (typeof this.isActive == "function") {
			this.active = this.isActive(null);
		} else {
			this.active = this.isActive;
		}
		this.lastIdAlternative = this.alternatives?.length ?? 0;
	}
};
</script>

<style scoped>
.add-text {
	padding: 8px;
	text-decoration: underline;
	cursor: pointer;
}
.deleteQuestionIcon {
	font-size: 23px !important;
}
</style>

<style>
.roundedCheckbox .custom-control-label::after {
	border-radius: 50% !important;
}
.roundedCheckbox .custom-control-label::before {
	border-radius: 50% !important;
}
</style>
